import { defineMessages } from 'react-intl-next';

export const i18n: {
    externalPersonLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	externalPersonLabel: {
		id: 'dynamic-cards-search-page.externalPersonLabel',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
});
